import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "app-confirm-dialog",
  templateUrl: "./confirm-dialog.component.html",
  styleUrls: ["./confirm-dialog.component.scss"],
})
export class ConfirmDialogComponent implements OnInit {
  skipCloudDeployment: boolean = true; 
  skipMessage: string = this.data?.skipMessage ? this.data.skipMessage : "Skip Cloud Deletion";
  constructor(
    public dialog: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      titleMessage: string;
      bodyMessage: string;
      cancelText: string;
      submitText: string;
      skipMessage?: string;
    }
  ) {
    this.dialog.backdropClick().subscribe(() => {
      this.onClose();
    });
  }

  ngOnInit(): void {}

  onSubmit() {
    if (this.data.titleMessage == "Delete Workstation") {
      this.dialog.close({
        confirmed: true,
        skipCloudDeployment: this.skipCloudDeployment
      });
    } else {
      this.dialog.close(true);
    }
  }

  onClose() {
    this.dialog.close(false);
  }

  getFormattedMessage(bodyMessage: string): string {
    if (bodyMessage.includes("'")) {
      const parts = bodyMessage.split("'");
      // bodyMessage: `Are you sure you want to delete custom action '${action.actionName}'`,
      // this is the get the last word action.actionName which is to be highlighted 
      const lastWord = parts[parts.length - 2];
      return `${parts[0]}' <span class="text-danger">${lastWord}</span> '`;
    }
    return bodyMessage;
  }
}
